import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { FormIdentifiers } from '../../../config/FormIdentifiers';

/**
 * PhoneBase
 *
 * A simple base layout for phone-focused screens.
 * Renders a centered Box with a maximum width of "small" (theme sm breakpoint).
 */
const PhoneBase = ({ name, children, sx }) => {
  if (!name) {
    console.error('name is required but was not provided.');
    return null;
  }

  return (
    <Box sx={{ height: '100%', bgcolor: 'grey.100', width: '100%' }}>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.common.white,
          overflow: 'auto',
          boxShadow: 1,
          borderRadius: 2,
          width: '100%',
          maxWidth: (theme) => `${theme.breakpoints.values.sm}px`,
          mx: 'auto',
          ...sx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

PhoneBase.propTypes = {
  name: PropTypes.oneOf(Object.values(FormIdentifiers)).isRequired,
  children: PropTypes.node,
};

export default PhoneBase;
